import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { ScheduleCollectiveEditConfirmTemplate } from 'components/Templates'

const ScheduleCollectiveEditConfirm: FC = () => {
  return (
    <Layout title={`確認 | 商品の受渡日を一括設定`}>
      <ScheduleCollectiveEditConfirmTemplate />
    </Layout>
  )
}

export default ScheduleCollectiveEditConfirm
